module.exports = __webpack_public_path__ + "static/media/de_CO2.e3d897df.svg";